import { IRefuelling, IRefuellingDetail, ITable, ServerResponse } from '../../models/models'
import { api } from '../api'

export const refuellingsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getRefuellings: builder.query<ITable<IRefuelling>, any>({
			query: (params) => ({
				url: 'refuellings',
				params,
			}),
			providesTags: ['refuellings'],
			transformResponse: (response: ServerResponse<ITable<IRefuelling>>) => ({
				...response.data,
				data: response.data.data.map((i) => ({ ...i, entityId: i.id })),
			}),
		}),
		getRefuellingById: builder.query<IRefuellingDetail, { id: string | number }>({
			query: ({ id }) => ({
				url: `refuellings/${id}`,
			}),
			transformResponse: (response: ServerResponse<IRefuellingDetail>) => response.data,
		}),
		editRefuelling: builder.mutation<ServerResponse<any>, { id: string | number; value: number }>({
			query: ({ id, value }) => ({
				url: `refuellings/${id}`,
				method: 'PUT',
				body: {
					exciseInvoiceNumber: value,
				},
			}),
			invalidatesTags: ['refuellings'],
		}),
	}),
})

export const { useGetRefuellingsQuery, useGetRefuellingByIdQuery, useEditRefuellingMutation } = refuellingsApi
